import { AccordionActions } from '@material-ui/core';
import { withStyles, createStyles } from '@material-ui/core/styles';

export default withStyles(theme => createStyles({}))(AccordionActions);
